import type { GetRoadmaps200RoadmapsItemCreatorBasicInfo } from './getRoadmaps200RoadmapsItemCreatorBasicInfo';
import type { GetRoadmaps200RoadmapsItemCreatorSocial } from './getRoadmaps200RoadmapsItemCreatorSocial';

/**
 * 로드맵 생성자 정보
 */
export type GetRoadmaps200RoadmapsItemCreator = {
  /** 사용자 기본 정보 */
  basicInfo: GetRoadmaps200RoadmapsItemCreatorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetRoadmaps200RoadmapsItemCreatorSocial;
};
